module.exports = __webpack_public_path__ + "annualreview2018/static/pdfs/pages--resilience.b61b6ba.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdfs/pages--resilience.pdf
// module id = I7L0
// module chunks = 10